export default "__VITE_ASSET__B0niJn_G__"